import { render, staticRenderFns } from "./SponsorEdit.vue?vue&type=template&id=6205cb95&scoped=true&"
import script from "./SponsorEdit.vue?vue&type=script&lang=js&"
export * from "./SponsorEdit.vue?vue&type=script&lang=js&"
import style0 from "./SponsorEdit.vue?vue&type=style&index=0&id=6205cb95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6205cb95",
  null
  
)

export default component.exports